import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  notes: Yup.string().max(280, "Notes must be less than 280 characters"),
});

export default validationSchema;
